import { FC, PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import ContentContainer from './content-container.component';
import Footer from './footer.component';
import Header from './header.component';

interface Props {
  locationId: string;
  shouldShowCountryDropdown?: boolean;
}
export const KioskLayout: FC<PropsWithChildren<Props>> = ({
  children,
  locationId,
  shouldShowCountryDropdown = false,
}) => {
  return (
    <>
      <Header locationId={locationId} showCountrySelector={shouldShowCountryDropdown} />
      <ContentContainer>
        <div css={cardStyles(false)}>{children}</div>
      </ContentContainer>
      <Footer locationId={locationId} />
    </>
  );
};

const cardStyles = (_hasScroll: boolean) =>
  css({
    backgroundColor: theme.colors.white,
    boxShadow: theme.shadows.floating,
    padding: theme.spacing(2),
    borderRadius: theme.borderRadius.medium,

    // ...(hasScroll && {
    //   '.footer-button-container': {
    //     position: 'fixed',
    //     bottom: 0,
    //     left: 0,
    //     right: 0,
    //     zIndex: 1000,
    //     backgroundColor: theme.colors.white,
    //     boxShadow: theme.shadows.floating,
    //   },
    // }),
  });
